module.exports = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgOTYgOTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIGlkPSJJY29uc19TbWFydFBob25lIiBvdmVyZmxvdz0iaGlkZGVuIj48cGF0aCBkPSJNNjYgODAgMzAgODAgMzAgMTYgNjYgMTYgNjYgODBaTTQ0IDggNTIgOEM1My4xIDggNTQgOC45IDU0IDEwIDU0IDExLjEgNTMuMSAxMiA1MiAxMkw0NCAxMkM0Mi45IDEyIDQyIDExLjEgNDIgMTAgNDIgOC45IDQyLjkgOCA0NCA4Wk03MCA0IDI2IDRDMjQuOSA0IDI0IDQuOSAyNCA2TDI0IDkwQzI0IDkxLjEgMjQuOSA5MiAyNiA5Mkw3MCA5MkM3MS4xIDkyIDcyIDkxLjEgNzIgOTBMNzIgNkM3MiA0LjkgNzEuMSA0IDcwIDRaIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./static/img/landing/card2-2.svg
// module id = CbMR
// module chunks = 1